module.exports = __webpack_public_path__ + "img/drugs_beerMJ.aa3f1f84.png";